export default __webpack_public_path__ + "static/media/Calendar.d84bdf70.svg";